export const EDeliveryFulfillmentType = {
  DeliveryOnly: 0,

  PickupOnly: 1,

  Both: 2,
} as const

export type EDeliveryFulfillmentType = (typeof EDeliveryFulfillmentType)[keyof typeof EDeliveryFulfillmentType]
